"use client"

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import OfertouLogo from "../../assets/logo-homepage.svg";
import Footer from "../../components/Footer";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: #e9e2db;
  font-family: 'Roboto', sans-serif;
  overflow-x: hidden;
`;

const ServerError = () => {
  return (
    <Container>
      <main className="flex-grow flex flex-col">
        {/* Header */}
        <header className="bg-[#e9e2db] py-5 px-4 sm:px-6 md:px-12 lg:px-24 w-full sticky top-0 z-50">
          <div className="flex items-center justify-between max-w-[1400px] mx-auto">
            <a href="/" className="mr-8">
              <img src={OfertouLogo} alt="Ofertou Logo" width={130} height={45} className="h-10 w-auto" />
            </a>
            <nav className="hidden md:flex space-x-12">
              <a href="/app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
                Ofertas
              </a>
              <a
                href="/#como-funciona"
                className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors"
              >
                Como Funciona
              </a>
              <a href="https://espera.ofertou.app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
                Divulgar produtos
              </a>
            </nav>
            <div className="md:hidden flex items-center">
              <button className="p-2 text-[#212121]">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>
        </header>

        {/* Error Content */}
        <div className="flex-grow flex flex-col items-center justify-center px-4 py-16 sm:py-24">
          <div className="text-center max-w-md mx-auto">
            <h1 className="text-9xl font-bold text-[#FF0000]">500</h1>
            <h2 className="mt-6 text-3xl font-bold text-[#212121]">Erro no servidor</h2>
            <p className="mt-4 text-lg text-gray-600">
              Desculpe, estamos enfrentando problemas técnicos no momento. Nossa equipe já foi notificada e está trabalhando para resolver o problema.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#eb6813] hover:bg-[#d25700] transition-colors"
              >
                Voltar para a página inicial
              </Link>
              <a
                href="https://wa.me/12991895138"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border border-[#469B54] text-base font-medium rounded-md text-[#469B54] bg-transparent hover:bg-[#469B54] hover:text-white transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
                  <path
                    d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.57-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
                    fill="currentColor"
                  />
                </svg>
                Contatar suporte
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </Container>
  );
};

export default ServerError;
